<template>
  <div>
    <page-title-bar></page-title-bar>
    <v-container fluid grid-list-xl pt-0>
      <v-layout row wrap>
        <app-card :fullBlock="true" colClasses="xs12">
          <v-card-title>
            <!-- <v-btn @click="sendBroadcast" outline color="success">
              <v-icon>zmdi-mail-send</v-icon>
              <span class="mx-2">{{ $t('message.sendMessage') }}</span>
            </v-btn> -->
            <v-spacer></v-spacer>
            <v-text-field
              append-icon="search"
              hide-details
              :label="$t('message.search')"
              single-line
              v-model="search"
            ></v-text-field>
          </v-card-title>

          <v-data-table 
            :headers="headers" 
            :items="ticketUsers" 
            :search="search"
            :loading="loading"
          >
            <template slot="headerCell" slot-scope="props">
              <v-tooltip bottom>
                <span slot="activator">{{ $t(`message.${props.header.text}`) }}</span>
                <span>{{ $t(`message.${props.header.text}`) }}</span>
              </v-tooltip>
            </template>
            <template slot="items" slot-scope="props">
              <td>{{ props.item.fullName }}</td>
              <td>{{ props.item.email }}</td>
              <td class="text-justify">{{ isSet(props.item.username) }}</td>
              <td>{{ props.item.created_at }}</td>
              <td>{{ props.item.telegram_id }}</td>
              <td>{{ props.item.total_purchases }}</td>
            </template>
          </v-data-table>
        </app-card>
      </v-layout>
    </v-container>
    <!-- <user-message :broadcast="broadcast" :dialog.sync="showSendMessage" ref="userMessage"></user-message> -->
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { generateFullNameProp } from "../../../helpers/helpers";
import { GET_TICKET_USERS } from "../../../store/modules/ticket-users/actions.type";
// import UserMessage from "./UserMessage";

export default {
  // components: {
  //   UserMessage
  // },
  data() {
    return {
      headers: [
        { text: "name", sortable: true, value: "fullName" },
        { text: "email", sortable: true, value: "email"},
        { text: "telegramUser", sortable: true, value: "username" },
        {
          text: "startDate",
          sortable: true,
          value: "created_at"
        },
        { text: "telegramId", sortable: true, value: "telegram_id" },
        { text: "purchase", sortable: true, value: "total_purchases" },
        // { text: "actions", sortable: false, value: "actions" }
      ],
      search: "",
      users: []
    };
  },
  computed: {
    ...mapGetters(["ticketUsers", "loading"])
  },
  created() {
    this.getTicketUsers();
  },
  methods: {
    getTicketUsers() {
      this.$store.dispatch(GET_TICKET_USERS)
      .catch((error) => {
        console.error(error);
      });
    },
    isSet(item) {
      return item == "Not set" ? "" : item;
    }
  }
};
</script>

<style>
</style>
